import React from 'react';
import PropTypes from 'prop-types';

import styles from './formGroup.module.scss';
import classNames from 'classnames';

const FormGroup = ({ direction, children, className }) => {
  return (
    <div className={classNames(styles[direction], className)}>{children}</div>
  );
};

FormGroup.propTypes = {
  direction: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
};

export default FormGroup;
